
// how long to display success message before closing the window (in ms)
export const successMsgDuration = 5000;

export const paymentMethods = [
    "Credit Card",
    "PayPal"
]

export const carouselItemsPerPage = 4;